<template>
  <div class="detail__limit-fill">
    <div class="detail__limit-segment" :class="'detail__limit-segment--' + barStatus" :style="{width: confirmedWidth}"></div>
    <div class="detail__limit-segment detail__limit-segment--frozen" :style="{width: frozenWidth}"></div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, PropType} from 'vue'
import MoneyDTO from "@/models/MoneyDTO";
import {resolveBarStatus, splitSum} from "@/service/requisiteFrozenSums";

export default defineComponent({
  props: {
    total: {type: Object as PropType<MoneyDTO>, required: true},
    frozen: {type: Object as PropType<MoneyDTO | null>, default: null},
    limit: {type: Object as PropType<MoneyDTO>, required: true},
    active: {type: Boolean, default: true},
  },
  setup(props) {
    const parts = computed(() => splitSum(props.total, props.frozen, props.limit))
    const barStatus = computed(() => resolveBarStatus(props.total, props.limit, props.active))

    const confirmedPercent = computed(() => Math.min(100, parts.value.confirmed / parts.value.max * 100))
    const frozenPercent = computed(() => Math.min(100 - confirmedPercent.value, parts.value.frozen / parts.value.max * 100))

    return {
      barStatus,
      confirmedWidth: computed(() => confirmedPercent.value + '%'),
      frozenWidth: computed(() => frozenPercent.value + '%'),
    }
  }
})
</script>
